import React from "react";
import { Table, Card, Button, Tooltip } from "antd";
import useLearners from  "PlatForms/OrgLMS/Hooks/ManagerHooks/useLearners";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const EmployeeGroup = () => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const managerId = localStorage.getItem("personalId");
  const { learners, loading, pagination, handlePageChange } = useLearners(managerId);
  const navigate = useNavigate();
  const handleNavigation = (path, state) => {
    if (isBlocked) return;
    navigate(path, { state });
  };
  const columns = [
    {
      title: "Name",
      render: (text, record) => `${record.firstName} ${record.lastName}`,
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone",
      dataIndex: "phoneNo",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Business Group Name",
      dataIndex: "businessGroupName",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Assigned Date",
      dataIndex: "managerAssignedDate",
      render: (date) => (date ? new Date(date).toLocaleString() : "N/A"),
    },
  ];
  return (
    <>
      <Card
        title="Employee List"
        loading={loading}
        style={{ opacity: isBlocked ? 0.6 : 1 }}
      >
        <Table
          rowKey="learnerId"
          dataSource={learners}
          columns={columns.filter(col => col.title !== "Actions")}
          scroll={{ x: "max-content" }}
          pagination={{
            current: pagination.pageNumber,
            pageSize: pagination.pageSize,
            total: pagination.totalCount,
            onChange: handlePageChange,
            showSizeChanger: false,
          }}
          expandable={{
            expandedRowRender: (record) => {
              const isDisabled = !record.businessGroupName || isBlocked;
              const tooltipText = isDisabled ?
                (!record.businessGroupName ? "No Business Group assigned" : "Complete your profile first")
                : "";
              return (
                <div style={{ display: 'flex', marginLeft: '50px', flexWrap: 'wrap', gap: '12px' }}>
                  <Tooltip title={tooltipText}>
                    <Button
                      onClick={() => handleNavigation("/training-recomends", {
                        learnerId: record.learnerId
                      })}
                      disabled={isDisabled}
                      style={{
                        opacity: isDisabled ? 0.6 : 1,
                        backgroundColor: '#9A6B0Eff',
                        borderColor: '#9A6B0Eff',
                        color: '#fff'
                      }}
                    >
                      Recommend Training
                    </Button>
                  </Tooltip>
                  <Tooltip title={isBlocked ? "Complete your profile first" : ""}>
                    <Button
                      type="primary"
                      onClick={() => handleNavigation("/check-reviews", {
                        learnerId: record.learnerId,
                        firstName: record.firstName,
                        lastName: record.lastName
                      })}
                      disabled={isBlocked}
                      style={{
                        opacity: isDisabled ? 0.6 : 1,
                        backgroundColor: '#9A6B0Eff', // Sea Green
                        borderColor: '#9A6B0Eff',
                        color: '#fff'
                      }}
                    >
                      Performance Review
                    </Button>
                  </Tooltip>
                  <Tooltip title={isDisabled ? tooltipText : ""}>
                    <Button
                      type="primary"
                      disabled={isDisabled}
                      onClick={() => handleNavigation("/perfomance-review-disc-assessment", {
                        learnerId: record.learnerId,
                        firstName: record.firstName,
                        lastName: record.lastName
                      })}
                      style={{
                        opacity: isDisabled ? 0.6 : 1,
                        backgroundColor: '#9A6B0Eff', // Sea Green
                        borderColor: '#9A6B0Eff',
                        color: '#fff'
                      }}
                    >
                      DISC+PerformanceRev
                    </Button>
                  </Tooltip>
                </div>
              );
            }
          }}
        />
      </Card>
    </>
  );
};
export default EmployeeGroup;